import { loadStripe } from '@stripe/stripe-js';

let _promise = null;
let _pk = null;

export function getStripePromise(publishableKey) {
    if (_promise && _pk === publishableKey) return _promise;
    _pk = publishableKey;
    // advancedFraudSignals: false — app is embedded 3 levels deep
    // (www.tempcomputing.com -> app.tempcomputing.com iframe -> Stripe's own
    // iframe). Stripe.js's ancestor-chain probe for this signal throws a
    // benign cross-origin SecurityError in that configuration; it does not
    // affect Stripe's server-side Radar scoring or 3DS/SCA.
    _promise = loadStripe(publishableKey, { advancedFraudSignals: false });
    return _promise;
}

export function warmStripe(publishableKey) {
    getStripePromise(publishableKey);
}
